import React from "react";
import { Box, Typography, keyframes } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";

// Define the heartbeat animation
const heartbeat = keyframes`
  0% {
    transform: scale(1);
  }
  14% {
    transform: scale(1.3);
  }
  28% {
    transform: scale(1);
  }
  42% {
    transform: scale(1.3);
  }
  70% {
    transform: scale(1);
  }
`;

const Loading = ({ message = "Loading...", backgroundImage, mainColor = "#e91e63", backgroundColor = "rgba(255, 255, 255, 0.9)" }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // backgroundColor: backgroundImage ? "transparent" : backgroundColor,
        zIndex: 9999999,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          backgroundColor: backgroundImage ? "rgba(255, 255, 255, 0.8)" : "transparent",
          padding: 4,
          borderRadius: 4,
        }}
      >
        <FavoriteIcon
          sx={{
            fontSize: 60,
            color: "#e91e63",
            animation: `${heartbeat} 1.5s ease-in-out infinite both`,
          }}
        />
        <Typography
          variant="h6"
          sx={{
            color: "#555",
            fontFamily: '"Noto Sans Thai", sans-serif',
            fontWeight: 500,
            letterSpacing: 1,
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default Loading;
